import { createIcon, IconColors } from './icon-utils';

export const ReportsIcon = createIcon({
  fill: IconColors.LightGray,
  height: 24,
  path: 'M16.188 18.563V8.624c0-.725.587-1.313 1.312-1.313h2.25c.725 0 1.313.588 1.313 1.313v10.273a.75.75 0 0 1-.625 1.165H3.563a.75.75 0 0 1-.626-1.165V12c0-.725.588-1.313 1.313-1.313H6.5c.725 0 1.313.588 1.313 1.313v6.563h1.75V5.25c0-.725.587-1.313 1.312-1.313h2.25c.725 0 1.313.588 1.313 1.313v13.313h1.75zm1.5 0h1.875v-9.75h-1.875v9.75zm-4.75 0V5.438h-1.876v13.125h1.876zm-8.5 0h1.875v-6.375H4.438v6.374z',
  width: 24,
});
